(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vivazz-card-colors"] && !Shopify.designMode) return;
  try {
    class VivazzCardColors extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.card = this.closest('[data-vivazz-card]');
      if (!this.card) return;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.vivazz-card-color');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        this.select(button);
      });
      this.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const buttons = [...this.querySelectorAll('button')];
        const current = buttons.indexOf(event.target);
        if (current < 0) return;
        event.preventDefault();
        event.stopPropagation();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 :
          (current + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[index].focus({ preventScroll: true });
        this.select(buttons[index]);
      });
      const initial = this.querySelector('[aria-pressed="true"]') || this.querySelector('button');
      if (initial) this.select(initial, false);
    }

    select(button, scroll = true) {
      const data = button.dataset;
      const card = this.card;
      for (const sibling of this.querySelectorAll('button')) sibling.setAttribute('aria-pressed', String(sibling === button));
      card.dataset.vivazzVariantId = data.variantId;
      card.dataset.vivazzColorSelected = data.color;
      const productPath = new URL(this.dataset.productUrl, location.origin).pathname.split('/products/')[1];
      for (const link of card.querySelectorAll('a[href]')) {
        const url = new URL(link.href, location.origin);
        if (url.pathname.split('/products/')[1] !== productPath) continue;
        url.searchParams.set('variant', data.variantId);
        link.href = url.href;
      }
      const gallery = card.querySelector('.card-gallery');
      let image = gallery?.querySelector('.vivazz-card-preview');
      if (gallery && data.image && !image) {
        image = document.createElement('img');
        image.className = 'vivazz-card-preview';
        image.width = 800;
        image.height = 800;
        image.loading = 'lazy';
        gallery.append(image);
      }
      image ||= card.querySelector('[data-vivazz-card-image], .resource-card__image:not(.resource-card__image--secondary)');
      if (image && data.image) {
        const sameImage = image.getAttribute('src') &&
          new URL(image.getAttribute('src'), location.origin).pathname === new URL(data.image, location.origin).pathname;
        if (!sameImage || scroll) {
          if (!image.sizes) image.sizes = '(max-width: 749px) 45vw, (max-width: 1199px) 33vw, 25vw';
          if (data.imageSrcset) image.srcset = data.imageSrcset;
          image.src = data.image;
        }
        image.alt = data.imageAlt;
        card.dataset.featuredMediaUrl = data.image;
        const transition = card.closest('product-card-link');
        if (transition) transition.dataset.featuredMediaUrl = data.image;
      }
      const sale = Number(data.compare) > Number(data.price);
      for (const price of card.querySelectorAll('[data-vivazz-card-price], [ref="priceContainer"] .price')) price.textContent = data.priceLabel;
      for (const compare of card.querySelectorAll('[data-vivazz-card-compare], [ref="priceContainer"] .compare-at-price')) {
        compare.textContent = data.compareLabel;
        compare.hidden = !sale;
      }
      for (const group of card.querySelectorAll('[ref="priceContainer"] .price__regular')) group.classList.toggle('price__hidden', sale);
      for (const group of card.querySelectorAll('[ref="priceContainer"] .price__sale')) group.classList.toggle('price__hidden', !sale);
      for (const badge of card.querySelectorAll('[data-vivazz-card-discount]')) {
        badge.hidden = !sale;
        badge.textContent = sale ? `-${Math.floor((1 - Number(data.price) / Number(data.compare)) * 100)}%` : '';
      }
      const quickAdd = card.querySelector('quick-add-component');
      if (quickAdd?.dataset.productOptionsCount === '1') {
        quickAdd.dataset.quickAddButton = 'add';
        const input = quickAdd.querySelector('input[name="id"]');
        if (input) { input.value = data.variantId; input.disabled = data.available !== 'true'; }
        const add = quickAdd.querySelector('.quick-add__button--add');
        if (add) add.disabled = data.available !== 'true';
      }
      if (scroll) {
        const left = button.offsetLeft;
        if (left < this.scrollLeft) this.scrollLeft = left;
        else if (left + button.offsetWidth > this.scrollLeft + this.clientWidth) this.scrollLeft = left + button.offsetWidth - this.clientWidth;
      }
    }

    static seedQuickBuy(product, variantId, container, image) {
      const variant = product.variants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;
      if (image && variant.featured_image?.src) image.src = variant.featured_image.src;
      product.options.forEach((option, index) => {
        if (!/^colou?r$/i.test(option.name) && option.values.length !== 1) return;
        const value = variant.options[index];
        const button = [...container.querySelectorAll('button[data-option-name]')].find((item) =>
          item.dataset.optionName === option.name && item.dataset.optionValue === value);
        button?.click();
      });
    }
  }
  if (!customElements.get('vivazz-card-colors')) customElements.define('vivazz-card-colors', VivazzCardColors);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vivazz-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vivazz-size-guide')) {
    customElements.define('vivazz-size-guide', class extends HTMLElement {
      static preferredUnit = 'cm';
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.setUnit(this.constructor.preferredUnit);
        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const dialog = this.querySelector('dialog');
          if (event.target.closest('[data-size-guide-open]')) {
            event.preventDefault();
            this.setUnit(this.constructor.preferredUnit);
            dialog.showModal();
            return;
          }
          if (event.target.closest('[data-size-guide-close]')) {
            dialog.close();
            return;
          }
          if (event.target === dialog) {
            const bounds = dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
            return;
          }
          const button = event.target.closest('[data-size-unit-button]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          const unit = button.dataset.sizeUnitButton;
          this.constructor.preferredUnit = unit;
          document.querySelectorAll('vivazz-size-guide').forEach((guide) => guide.setUnit(unit));
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.querySelector('dialog[open]')?.close(); this.controller?.abort(); }
      setUnit(unit) {
        this.dataset.unit = unit === 'in' ? 'in' : 'cm';
        this.querySelectorAll('[data-size-unit-button]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.sizeUnitButton === this.dataset.unit));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
